import { configureStore } from '@reduxjs/toolkit';
import recommendationsReducer from './slices/recommendationsSlice';
import metricsReducer from './slices/metricsSlice';
import monitorReducer from './slices/monitorSlice';

export const store = configureStore({
  reducer: {
    recommendations: recommendationsReducer,
    metrics: metricsReducer,
    monitor: monitorReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
